import translationFunction from 'src/presentation/components/pages/shared/utils/translateObjectFields';

const mapOfTranslations = [['<EMAILADDRESS>', '{{._customerEmailAddress}}']];

export const translate = <T>(value: T, options: { reverse: boolean } = { reverse: false }): T =>
  translationFunction(value, options, mapOfTranslations);
